<script setup>
import axios from 'axios';
import { onMounted, ref, computed } from "vue";
import { FilterMatchMode,FilterOperator } from '@primevue/core/api';
import { pVentasRequest } from '../api/invoices';
import { municipality } from '../api/technicalAnnex';

import InputText from 'primevue/inputtext';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Select from 'primevue/select';
import DatePicker from 'primevue/datepicker';
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';
const { format } = require("date-fns");

// Fecha actual
const today = new Date();
const formattedToday = format(today, "MM/dd/yyyy");

// Fecha del día anterior
const filters = ref();
const initFilters = () => {
  filters.value = {
    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
     nombre: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
  };
}

initFilters();

const activeSpinner = ref(false)
const pventas = ref([]);
const selectedPventa = ref('');
const data_from = ref(formattedToday);
const columns = [
  { field: 'fecha_creacion', header: 'Fecha' },
];

const cuadres = ref([]);
const cuadresFiltrados = ref([]);

//ObjetsArray Municipios && Departamentos
const munDep = ref([]);
const municipalities = ref([]);
const departments = ref([]);
const selectedDeparment = ref(null);
const selectedCodeDeparment = ref(null);
const selectedMunicipaly = ref(null);
const selectedCodeMunicipaly = ref(null);

const resetFilter = () => {
  data_from.value = null;
  selectedPventa.value = '';
  selectedDeparment.value = null;
  selectedCodeDeparment.value = null;
  selectedMunicipaly.value = null;
  selectedCodeMunicipaly.value = null;
  loadInfo();
}

const loadInfo = () => {
  const plano = cuadresPlano.value;

  if (!Array.isArray(plano)) {
    console.warn('cuadresPlano no está listo aún');
    return;
  }

  const filtroPunto = selectedPventa.value?.toLowerCase().replace(/_/g, '-') || '';
  const filtroFecha = data_from.value
    ? format(new Date(data_from.value), "yyyy-MM-dd")
    : '';

  cuadresFiltrados.value = plano.filter(item => {
    const coincidePunto = filtroPunto ? item.nombre === filtroPunto : true;
    const coincideFecha = item.fecha_creacion?.startsWith(filtroFecha);
    return coincidePunto && coincideFecha;
  });
};

const loadNameByPventa = async () => {
  try {
    let data = {department : selectedCodeDeparment.value,municipality: selectedCodeMunicipaly.value}
    let result = await pVentasRequest(data)
    pventas.value = result.data.data;
  } catch (error) {
    console.log(error);
  }
}

const loadMucipaly = async () => {
  let municipalitiesAndDepartments = await municipality();
  munDep.value = municipalitiesAndDepartments.data.data;
  department();
}

const showPdf = async (data) => {
  const nombre = data.nombre.replace(/-/g, '_').toUpperCase();
  const fecha = data.fecha_creacion.replace(/-/g, '_');
  const archivo = data.pdf;

  const urls = [
    `https://cuadrecaja.pruebasfenix.com/storage/app/public/cuadres_de_caja/${nombre}/${fecha}/${archivo}`,
    `https://cuadrecaja.pruebasfenix.com/storage/app/public/cuadres_de_caja/${nombre}/${fecha}/${archivo}`,
    `https://cuadrecaja.pos-fenix.com/storage/app/public/cuadres_de_caja/${nombre}/${fecha}/${archivo}`
  ];

  for (const url of urls) {
    try {
        window.open(url, '_blank');
        return;
    } catch (error) {
      console.warn(`Error al verificar la URL: ${url}`, error);
    }
  }

  // Si ninguna URL es válida
  alert('No se pudo encontrar el archivo en ninguna de las URLs.');
};

const showPaper = async (data, index) => {
  const nombre = data.nombre.replace(/-/g, '_').toUpperCase();
  const fecha = data.fecha_creacion.replace(/-/g, '_');
  const archivo = data.imagenes[index];

  const urls = [
    `https://cuadrecaja.pruebasfenix.com/storage/app/public/cuadres_de_caja/${nombre}/${fecha}/${archivo}`,
    `https://cuadrecaja.pruebasfenix.com/storage/app/public/cuadres_de_caja/${nombre}/${fecha}/${archivo}`
  ];

  for (const url of urls) {
    try {
        window.open(url, '_blank');
        return;
    } catch (error) {
      console.warn(`Error al verificar la URL: ${url}`, error);
    }
  }

  // Si ninguna URL es válida
  alert('No se pudo encontrar el archivo en ninguna de las URLs.');
};

const department = () => {
  departments.value = munDep.value.reduce((acc, curr) => {
    const existing = acc.find(item => item.departamento === curr.nombre_departamento);
    return existing ? acc : [...acc, { codigo: curr.codigo_departamento, departamento: curr.nombre_departamento }];
  }, []);
}

const municipalityAndCode = () => {
  selectedCodeDept();
  selectedCodeMunicipaly.value = null;
  municipalities.value = [];
  const code = selectedCodeDeparment.value
  municipalities.value = munDep.value
  .filter(item => item.codigo_departamento === code)
  .map(item => ({
    codigo: item.codigo_municipio,
    municipio: item.nombre_municipio
  }));
  loadNameByPventa();
}

const selectedCodeDept = () => {
  let code = selectedDeparment.value.codigo != undefined ? selectedDeparment.value.codigo : selectedDeparment.value;
  selectedCodeDeparment.value =  code
}

const selectedCodeMun = () => {
  let code = selectedMunicipaly.value.codigo != undefined ? selectedMunicipaly.value.codigo : selectedMunicipaly.value;
  selectedCodeMunicipaly.value = code;
  loadNameByPventa()
}

const getCuadres = async () => {
  try {
    const urls = [
      'https://cuadrecaja.pruebasfenix.com/public/api/get-documentos',
      'https://cuadrecaja.pruebasfenix.com/public/api/get-documentos'
    ];

    let combined = {}; // ahora es un objeto, no un array

    for (const url of urls) {
      const response = await axios.get(url);
      const data = response.data;

      for (const puntoVenta in data) {
        if (combined[puntoVenta]) {
          combined[puntoVenta] = {
            ...combined[puntoVenta],
            ...data[puntoVenta]
          };
        } else {
          combined[puntoVenta] = data[puntoVenta];
        }
      }
    }

    cuadres.value = combined;

  } catch (error) {
    console.error('Error al obtener los cuadres:', error);
  }
};

const cuadresPlano = computed(() => {
  const resultado = [];

  for (const [pventa, fechas] of Object.entries(cuadres.value)) {
    for (const [fecha, archivos] of Object.entries(fechas)) {
      const pdf = archivos.find(nombre => nombre.endsWith('.pdf'));
      const imagenes = archivos.filter(nombre => nombre.endsWith('.jpg') || nombre.endsWith('.jpeg') || nombre.endsWith('.png'));

      resultado.push({
          nombre: pventa.replace(/_/g, '-').toLocaleLowerCase(),
          fecha_creacion: fecha.replace(/_/g, '-'),
        pdf,
        imagenes
      });
    }
  }

  return resultado;
});

onMounted(() => {
  loadNameByPventa();
  loadMucipaly();
  getCuadres().then(() => {
    loadInfo();
  });
});

</script>
<template>
  <div class="py-4 container-fluid">
    <Toast />
    <ConfirmDialog></ConfirmDialog>
    <div class="d-flex justify-content-center align-content-center">
      <div class="col-lg-12 col-md-6 col-12">
        <div class="mb-3 card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <label for="selectedDeparment" class="form-label">Departamento</label>
                <Select  v-model="selectedDeparment" @change="municipalityAndCode" :options="departments" filter optionLabel="departamento" class="form-select form-select-sm" />
              </div>
              <div class="col-md-4">
                <label for="selectedMunicipaly" class="form-label">Municipio</label>
                <Select  v-model="selectedMunicipaly" @change="selectedCodeMun" :options="municipalities" filter optionLabel="municipio" class="form-select form-select-sm" />
              </div>
              <div class="col-md-4">
                <label class="form-label">Punto De Venta</label>
                <Select  v-model="selectedPventa" :options="pventas" filter optionValue="nombre" optionLabel="nombre" class="form-select form-select-sm" />
              </div>
              <div class="col-md-4">
                <label class="form-label">Fecha</label><br>
                <DatePicker class="input" v-model="data_from" />
              </div>
              <div class="col-md-4">
                <button class="btn btn-link mt-4 py-3" @click="loadInfo">
                  <i class="fa fa-search" aria-hidden="true" />
                </button>
                <button class="btn btn-link mt-4 py-3" @click="resetFilter">
                  <i class="fa fa-broom"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card z-index-2">
      <div class="row p-4">
        <div class="col-md-3">
          <IconField>
            <InputIcon><i class="pi pi-search" /></InputIcon>
            <InputText class="input" v-model="filters['global'].value" placeholder="Buscar..." />
          </IconField>    
        </div>
      </div>
      <div class="col-lg-12 mb-lg-0 mb-4">
        <div class="card">
          <div class="mt-3 px-2">
            <div v-if="activeSpinner" class="flex justify-content-center align-items-center text-center mb-5">
              <i class="pi pi-spin pi-spinner" style="font-size: 3rem"></i>
            </div>
            <DataTable 
              v-if="!activeSpinner"
              class="m-3" 
              :value="cuadresFiltrados" 
              :paginator="true" 
              :rows="5"
              :rowsPerPageOptions="[5, 10, 20, 50]" 
              :filters="filters"
              stripedRows 
              resizableColumns 
              columnResizeMode="fit" 
              showGridlines 
              tableStyle="min-width: 50rem"
              v-model:filters="filters" 
              filterDisplay="menu"
              :globalFilterFields="['nombre']"
              sortField="fecha_creacion"
              :sortOrder="-1"
            >
              <Column field="nombre" header="Pventa" style="min-width: 12rem">
                <template #body="{ data }">
                  {{ data.nombre }}
                </template>
                <template #filter="{ filterModel }">
                    <InputText v-model="filterModel.value" type="text" placeholder="Search by nombre" />
                </template>
              </Column>
              <Column v-for="col of columns" :key="col.field" :field="col.field" :header="col.header" sortable></Column>
              <Column :exportable="false" header="Opciones" style="min-width: 1rem">
                <template #body="slotProps" >
                    <Button icon="pi pi-file-pdf" outlined rounded class="button-margin" title="PDF" severity="danger" @click="showPdf(slotProps.data)" />
                    <Button
                        v-for="(img, index) in slotProps.data.imagenes"
                        :key="index"
                        icon="pi pi-images"
                        outlined
                        rounded
                        :severity="[img.startsWith('cuadre') ? 'help' : 'primary']"
                        class="button-margin"
                        :title="[img.startsWith('cuadre') ?  `Imagen tirilla ${index + 1}` : `Imagen Factura ${index + 1}`]"
                        @click="showPaper(slotProps.data, index)"
                    />
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<style scoped>

.input {
  height: 3rem !important;
  width: 100%;
}

.button-margin {
    margin-right: 8px;
}

::v-deep(.p-datepicker .p-inputtext) {
  cursor: pointer !important;
}
</style>
